import React from "react"
import {
    componentStyles,
    VerticalStack,
} from "@mallardbay/lib-react-components"

import OutfitterLicensedPill from "~components/pages/outfitter/outfitter-info/outfitter-licensed-pill"
import OutfitterSection from "~components/shared/todo-lib-react-components/outfitter-info/outfitter-section"
import OwnerSection from "~components/shared/todo-lib-react-components/outfitter-info/owner-section"
import ShareOutfitterButton from "~components/pages/outfitter/outfitter-info/share-outfitter-button"
import Card from "~components/shared/card"
import Divider from "~components/shared/divider"
import { TEST_IDS } from "~config/test-ids"
import { useCurrentOutfitter } from "~components/providers/current-outfitter-provider"
import { VerticalStackStretch } from "~components/shared/todo-lib-react-components/vertical-stack"
import ContactSupportBanner from "~components/contact-support-banner"

export default function OutfitterInfoDesktop() {
    const { currentOutfitter } = useCurrentOutfitter()
    const styles = useStyles()

    return (
        <VerticalStackStretch style={styles.vStack}>
            <Card noPadding testId={TEST_IDS.OUTFITTER_INFO_DESKTOP}>
                <VerticalStack style={styles.root}>
                    <OutfitterSection
                        outfitter={currentOutfitter}
                        location={currentOutfitter.location}
                    />
                    <OutfitterLicensedPill />
                    <OwnerSection outfitter={currentOutfitter} />
                </VerticalStack>
                <Divider />
                <ShareOutfitterButton />
            </Card>
            <ContactSupportBanner shouldShowEmail />
        </VerticalStackStretch>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            padding: "24px",
        },
        vStack: {
            marginBottom: "24px",
        },
    })
}
